import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
/**
 * 批量更改对象中的 key 键
 * @param {obj} obj - 原始对象
 * @param {obj} keyMap - 要修改的 key 值
 * @returns { obj } - 处理后的对象
 */
export function mapKeys(obj, keyMap) {
  return Object.keys(obj).reduce(function (acc, key) {
    acc[keyMap[key] || key] = obj[key];
    return acc;
  }, {});
}